import SquaberIntervalTypes from "./SquaberIntervalTypes";
import quoteStreamService from "../Firebase/QuoteStreamService";

class SquaberTVQuotationNotifier {
  subscribers = {};
  quoteUnsubscribers = {};

  constructor(stockId, iterateOverIntervals) {
    this.stockId = stockId;
    this.iterateOverIntervals = iterateOverIntervals;

    for (let intervalTypeId of Object.values(SquaberIntervalTypes)) {
      this.subscribers[intervalTypeId] = {};
      this.quoteUnsubscribers[intervalTypeId] = {};
    }
  }

  subscribe(market, ticker, intervalTypeId, notifyCallback) {
    if (this.quoteUnsubscribers?.[intervalTypeId]?.[this.stockId]) {
      this.quoteUnsubscribers[intervalTypeId][this.stockId]();
    }

    this.subscribers[intervalTypeId][this.stockId] = notifyCallback;
    this.quoteUnsubscribers[intervalTypeId][this.stockId] =
      quoteStreamService.subscribe({
        stockId: this.stockId,
        intervalTypeId,
        onQuote: quoteData => this.notifyObservers(this.stockId, quoteData)
      });
  }

  unsubscribe(market, ticker, intervalTypeId) {
    this.quoteUnsubscribers?.[intervalTypeId]?.[this.stockId]?.();
    delete this.quoteUnsubscribers?.[intervalTypeId]?.[this.stockId];
    delete this.subscribers?.[intervalTypeId]?.[this.stockId];
  }

  notifyObservers(stockId, quote) {
    if (!quote) {
      return;
    }

    if (this.iterateOverIntervals) {
      const result = [];

      for (let intervalTypeId of Object.keys(this.subscribers)) {
        result.push(this.notifyObserver(stockId, quote, intervalTypeId));
      }

      return result;
    } else {
      return this.notifyObserver(
        stockId,
        quote,
        Number(quote["interval_type_id"])
      );
    }
  }

  notifyObserver(stockId, quote, intervalTypeId) {
    if (this.subscribers[intervalTypeId][stockId]) {
      return this.subscribers[intervalTypeId][stockId](quote);
    }
  }
}

export default SquaberTVQuotationNotifier;
